var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.task)?_c('div',{staticClass:"scope-of-works-task"},[_c('div',{staticClass:"task-info"},[_c('strong',[_vm._v(_vm._s(_vm.task.reference)+":")]),_vm._v(" "+_vm._s(_vm.task.title)+"\n    ")]),_vm._v(" "),(_vm.task.children.length)?_c('div',{staticClass:"children"},[_c('sow-looper',{attrs:{"items":_vm.task.children}})],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }